import { refreshAccessToken } from "../utils/refreshTokens";
import { ReactNode } from "react";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAccessToken } from "../utils/tokens";
import { fullAPIURL } from "./../utils/requests";

const httpLink = createHttpLink({
  uri: `${fullAPIURL}/v2/graph/graphql`,
});

const authLink = setContext(async (_, { headers }) => {
  const token = getAccessToken();

  if (!token) {
    return {
      headers,
    };
  }

  const { accessToken } = await refreshAccessToken(token);
  // no op if there is no refresh token
  if (!accessToken) {
    return {
      headers,
    };
  }

  return {
    headers: {
      authorization: `Bearer ${accessToken}`,
      ...headers,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

type ApolloContextProps = {
  children: ReactNode;
};

const ApolloContext = ({ children }: ApolloContextProps) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloContext;
